import React from 'react'
import { useState } from 'react'

const Header = ({clickEvenet,Msg}) => {
const [ip,setIp]=useState("");
    return (
        <div>
            <div className="header">
            <h1>IP address Tracher</h1>
            <div className="SearchBar">
                <input className="search" type="text" placeholder="Search for any IP address or domain" onChange={(e)=>{setIp(e.target.value)}} />
                
                <button className="btn" onClick={(e)=>{clickEvenet(ip)}}><img className="btnIcon" src="images/icon-arrow.svg" alt="right arrow"/></button>
            </div>
            {Msg &&<h4 className="msgEr">Ip not valid correct IPv4 or IPv6 address.</h4>}
        </div>
        </div>
    )
}

export default Header
